import * as React from 'react';
import { Element } from 'react-scroll';

import RealEstateGlobally from './RealEstateGlobally/RealEstateGlobally';
import ActiveCountries from './ActiveCountries/ActiveCountries';
import BuildingTypes from './BuildingTypes/BuildingTypes';
import ReadyToExplore from './ReadyToExplore/ReadyToExplore';
import AboutUs from './AboutUs/AboutUs';
import Team from './Team/Team';
import Cooperate from './Cooparete/Cooperate';
import Partners from './Partners/Parnters';
import ActiveWorldMap from './ActiveWorldMap/ActiveWorldMap';
import Contacts from './Contacts/Contacts';
import Links from '../../common/Links/Links';
import Data from './Data/Data';
import FlatfyDomainsLinker from '../../common/FlatfyDomainsLinker';

import * as styles from './HomePage.module.scss';

const HomePage = () => (
  <section className={styles.root}>
    <Links />
    <FlatfyDomainsLinker />
    <Element name="RealEstateGlobally">
      <RealEstateGlobally />
    </Element>
    <Element name="ActiveCountries">
      <ActiveCountries />
    </Element>
    <Element name="BuildingTypes">
      <BuildingTypes />
    </Element>
    <Element name="AboutUs">
      <AboutUs />
    </Element>
    <Element name="Data">
      <Data />
    </Element>
    <Element name="Team">
      <Team />
    </Element>
    <Element name="Cooperate">
      <Cooperate />
    </Element>
    <Element name="Partners">
      <Partners />
    </Element>
    <Element name="ReadyToExplore">
      <ReadyToExplore />
    </Element>
    <Element name="WorldMap" id="active-map">
      <ActiveWorldMap />
    </Element>
    <Element name="Contacts">
      <Contacts />
    </Element>
  </section>
);

export default HomePage;
